export default "__VITE_ASSET__zcUIv3ed__"